
import Component from 'vue-class-component';
import Vue from 'vue';
import { ModalState } from '@/core/types/modal-state';
import { Emit, Prop, Watch } from 'vue-property-decorator';

@Component
export default class LoanAutopaySkipConfirmModal extends Vue {
	public isShown = false;

	@Prop({ default: { isShown: false } })
	public state!: ModalState;

	public close(): void {
		this.isShown = false;
	}

	@Emit('skip')
	public emitSkip(): boolean {
		this.close();
		return true;
	}

	@Watch('state')
	public watchState(state: ModalState): void {
		this.isShown = state.isShown;
	}
}
